import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../../build/styles';
import { getCallbacks } from '../../helper/helper';

var CardHeaderIcon =
/*#__PURE__*/
function (_Component) {
  _inherits(CardHeaderIcon, _Component);

  function CardHeaderIcon() {
    _classCallCheck(this, CardHeaderIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(CardHeaderIcon).apply(this, arguments));
  }

  _createClass(CardHeaderIcon, [{
    key: "createClassName",
    value: function createClassName() {
      return [styles.cardHeaderIcon, this.props.className].join(' ').trim();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('a', _extends({}, getCallbacks(this.props), {
        style: this.props.style,
        className: this.createClassName()
      }), React.createElement('i', {
        className: [styles.fa, this.props.icon].join(' ').trim()
      }));
    }
  }]);

  return CardHeaderIcon;
}(Component);

export { CardHeaderIcon as default };
CardHeaderIcon.propTypes = {
  style: PropTypes.object,
  icon: PropTypes.string,
  className: PropTypes.string
};
CardHeaderIcon.defaultProps = {
  style: {},
  className: ''
};